import React from "react";
import {
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import moment from "moment";
import { FaCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import { Link } from "react-router-dom";

// 🎨 Estilos personalizados
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#f0f0f0",
    color: "#000",
    borderLeft: "1px solid #80808042",
    fontSize: 16,
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderLeft: "1px solid #80808042",
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "transparent",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#f3f3f3",
  },
  "&:hover": {
    cursor: "pointer",
    backgroundColor: "#e6f7ff",
  },
}));

// 📦 Componente principal
export default function CustomizedTables({
  rowsTitle = [],
  rowsValue = [],
  totalRows = 0,
  rowDateName = "",
  rowBoolean = "",
  rowLink = "",
  backgroundRowColor = () => {},
  onClickRowFunc = () => {},
}) {
  // 🔧 Renderiza una celda
  const renderCell = (row, key, bgColor) => {
    let value = row[key];
    let align = typeof value === "number" ? "center" : "left";

    if (key === rowDateName) {
      align = "center";
      value = moment(value).format("DD-MM-yyyy");
    }

    if (key === rowBoolean) {
      align = "center";
      value = value ? (
        <FaCheckCircle size="1rem" color="green" />
      ) : (
        <FaRegTimesCircle size="1rem" color="red" />
      );
    }

    const cellContent =
      rowLink === key ? (
        <Link
          to={`/Home/Empresa/Config/${row.id}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontWeight: "bold" }}
        >
          {value}
        </Link>
      ) : (
        value
      );

    return (
      <StyledTableCell sx={{ py: 0.5 }} key={key} align={align} style={{ background: bgColor }}>
        {cellContent}
      </StyledTableCell>
    );
  };

  return (
    <Grid margin={"1rem 0"}>
      <TableContainer component={Paper} elevation={8}>
        <Table sx={{ minWidth: 700 }} aria-label="tabla personalizada">
          <TableHead>
            <TableRow>
              <StyledTableCell sx={{ py: 1 }} align="center">#</StyledTableCell>
              {rowsTitle.map((title) => (
                <StyledTableCell sx={{ py: 1 }} key={title.key} align="center">
                  {title.name}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {rowsValue.map((row, index) => {
              const bgColor = backgroundRowColor(row) || "";

              return (
                <StyledTableRow
                  key={row.id || index}
                  onClick={() => onClickRowFunc(row)}
                >
                  <StyledTableCell style={{ background: bgColor }}>
                    {index + 1}
                  </StyledTableCell>

                  {rowsTitle.map(({ key }) => renderCell(row, key, bgColor))}
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Typography
        textAlign="left"
        fontWeight="bolder"
        margin="1rem"
        variant="h5"
      >
        Total registros: {rowsValue.length}
      </Typography>
    </Grid>
  );
}
